export default "__VITE_ASSET__C1lvq3j___"